import { render, staticRenderFns } from "./PopupNotices.vue?vue&type=template&id=401777ee&"
import script from "./PopupNotices.vue?vue&type=script&lang=js&"
export * from "./PopupNotices.vue?vue&type=script&lang=js&"
import style0 from "./PopupNotices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NoticesItem: require('/home/bitrix/lka/frontend/components/NoticesItem.vue').default})
